// extracted by mini-css-extract-plugin
export default {"container":"Resources_container__oPZaG","space":"Resources_space__x3FFV"};